module.exports = __webpack_public_path__ + "img/na.df32b38f.svg";